import { httpsCallable } from "firebase/functions";

import { cloudFunctions } from "./getFunctions";
import {
  EstablecerContrasenaUsuario,
  CloudFunctionResponse,
  CallablesGeneral
} from "@fixeduy/restaurantestypes";

const establecerContrasena = async (
  data: EstablecerContrasenaUsuario
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({
    func: "establecerContrasena",
    params: data
  });
  return result.data;
};

export { establecerContrasena };
